var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoScreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 101,
    viewBox: "0 0 100 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3870_19126)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 100,
    height: 100,
    rx: 50,
    fill: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3870_19126)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 33.5,
    width: 44,
    height: 71,
    rx: 4,
    fill: "white",
    fillOpacity: 0.65,
    shapeRendering: "crispEdges"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_3870_19126)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 44.5,
    width: 45,
    height: 57,
    rx: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 66.5,
    width: 35,
    height: 5,
    rx: 2.5,
    fill: "#EAEBEB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 74.5,
    width: 23,
    height: 5,
    rx: 2.5,
    fill: "#EAEBEB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 51.5,
    width: 13,
    height: 11,
    rx: 1,
    fill: "#EFF0F0"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_3870_19126)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 82,
    cy: 44.5,
    r: 8,
    fill: "#F73C58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.98 47.34C83.5 47.8467 82.8833 48.1 82.13 48.1C81.3767 48.1 80.76 47.8467 80.28 47.34C79.8 46.8267 79.56 46.17 79.56 45.37V43.51C79.56 42.71 79.8 42.0567 80.28 41.55C80.76 41.0367 81.3767 40.78 82.13 40.78C82.8833 40.78 83.5 41.0367 83.98 41.55C84.4667 42.0567 84.71 42.71 84.71 43.51V45.37C84.71 46.17 84.4667 46.8267 83.98 47.34ZM82.13 47.02C82.5767 47.02 82.9333 46.8733 83.2 46.58C83.4733 46.2867 83.61 45.8833 83.61 45.37V43.51C83.61 42.9967 83.4733 42.5933 83.2 42.3C82.9333 42.0067 82.5767 41.86 82.13 41.86C81.69 41.86 81.3333 42.0067 81.06 42.3C80.7933 42.5933 80.66 42.9967 80.66 43.51V45.37C80.66 45.8833 80.7933 46.2867 81.06 46.58C81.3333 46.8733 81.69 47.02 82.13 47.02Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M22.3338 22.3057L23.213 23.9542L24.8615 24.8334L23.213 25.7127L22.3338 27.3612L21.4545 25.7127L19.806 24.8334L21.4545 23.9542L22.3338 22.3057ZM16.3338 24.389L18.1115 27.7223L21.4449 29.5001L18.1115 31.2779L16.3338 34.6112L14.556 31.2779L11.2227 29.5001L14.556 27.7223L16.3338 24.389ZM24.1115 32.389L23.0005 30.3057L21.8893 32.389L19.806 33.5001L21.8893 34.6112L23.0005 36.6945L24.1115 34.6112L26.1949 33.5001L24.1115 32.389Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3870_19126",
    x: 14,
    y: 30.5,
    width: 52,
    height: 79,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.36 0 0 0 0 0.408 0 0 0 0 0.44 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3870_19126"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3870_19126",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_3870_19126",
    x: 24,
    y: 32.5,
    width: 77,
    height: 89,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.36 0 0 0 0 0.408 0 0 0 0 0.44 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3870_19126"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3870_19126",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_3870_19126",
    x: 70,
    y: 34.5,
    width: 24,
    height: 24,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.9 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3870_19126"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3870_19126",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3870_19126"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 100,
    height: 100,
    rx: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoScreen);
export default __webpack_public_path__ + "static/media/no-screen.34517b52d7c8f3b9ba7fb79a43434e10.svg";
export { ForwardRef as ReactComponent };